import clsx from 'clsx'
import { Typography } from '../../common/typography'
import classes from './LearningComponents.module.css'

export default function LearningProgress({
  completedPercent,
  inProgressPercent,
  notStartedPercent,
}: {
  completedPercent: number
  inProgressPercent: number
  notStartedPercent: number
}) {
  return (
    <div className={classes.learningBox}>
      <Typography
        fs="lg"
        fw={700}
        fc={{ light: 'black', dark: 'gray-3' }}
        lh="120"
      >
        Learning XP Progress
      </Typography>
      <div
        className={classes.progressContainer}
        style={
          {
            '--completed-width': `${completedPercent}%`,
            '--in-progress-width': `${inProgressPercent}%`,
            '--not-started-width': `${notStartedPercent}%`,
          } as React.CSSProperties
        }
      >
        <div className={clsx(classes.progressBar, classes.green)}>
          {completedPercent > 0 && (
            <Typography
              fs="xs"
              fc={{ light: 'white', dark: 'white' }}
              ff="JetBrains Mono"
              lh="140"
              ta="center"
            >
              {Math.round(completedPercent)}%
            </Typography>
          )}
        </div>
        <div className={clsx(classes.progressBar, classes.orange)}>
          {inProgressPercent > 0 && (
            <Typography
              fs="xs"
              fc={{ light: 'white', dark: 'white' }}
              ff="JetBrains Mono"
              lh="140"
              ta="center"
            >
              {Math.round(inProgressPercent)}%
            </Typography>
          )}
        </div>
        <div className={clsx(classes.progressBar, classes.gray)}>
          {notStartedPercent > 0 && (
            <Typography
              fs="xs"
              fc={{ light: 'white', dark: 'white' }}
              ff="JetBrains Mono"
              lh="140"
              ta="center"
            >
              {Math.round(notStartedPercent)}%
            </Typography>
          )}
        </div>
      </div>
      <div className={classes.learningLegend}>
        <div className={classes.learningLegendItem}>
          <span
            className={clsx(classes.learningItemIndicator, classes.green)}
          />
          <Typography fs="sm" fc={{ light: 'black', dark: 'gray-3' }} lh="140">
            Completed
          </Typography>
        </div>
        <div className={classes.learningLegendItem}>
          <span
            className={clsx(classes.learningItemIndicator, classes.orange)}
          />
          <Typography fs="sm" fc={{ light: 'black', dark: 'gray-3' }} lh="140">
            In Progress
          </Typography>
        </div>
        <div className={classes.learningLegendItem}>
          <span className={classes.learningItemIndicator} />
          <Typography fs="sm" fc={{ light: 'black', dark: 'gray-3' }} lh="140">
            Not Started
          </Typography>
        </div>
      </div>
    </div>
  )
}
